'use client';

import { c as _c } from "react/compiler-runtime";
import { Suspense, useState } from 'react';
import { Skeleton } from '@sola/ark-core/atoms/skeleton/skeleton.tsx';
import type { GeoLocationDto } from '@sola/skippy-search-sdk/lib/schema.ts';
import { useResolveLocation } from './volunteer-controls.logic.ts';
import { VolunteerFilter } from './volunteer-filter.tsx';
import { VolunteerList } from './volunteer-list.tsx';
const VolunteerFilterSkeleton = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="body-md md:align-center"><Skeleton height={20} width={120} /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="VolunteerFilter"><div className="VolunteerFilter__container flex flex-col md:flex-row md:justify-between md:align-center gap-comfy-lg">{t0}<div className="flex align-end md:justify-end md:align-center gap-comfy-sm"><Skeleton height={40} width={140} borderRadius="0.5rem" /><Skeleton height={40} width={80} borderRadius="0.5rem" /></div></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
type VolunteerControlsProps = {
  seoLevel?: number;
  q?: string;
  limit?: number;
  variant: 'default' | 'tour';
  slug?: string;
};
export const VolunteerControls = t0 => {
  const $ = _c(19);
  const {
    seoLevel,
    q,
    limit,
    variant,
    slug
  } = t0;
  const [volunteerCount, setVolunteerCount] = useState();
  const [userGeo, setUserGeo] = useState();
  const {
    resolved,
    isResolving
  } = useResolveLocation();
  const geoCoords = userGeo === undefined ? resolved?.geo : userGeo ?? undefined;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = t2 => {
      const {
        totalCount
      } = t2;
      setVolunteerCount(totalCount);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const onVolunteerLoad = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = newGeo => {
      setUserGeo(newGeo ?? null);
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleGeoChange = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <VolunteerFilterSkeleton />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== limit || $[4] !== resolved || $[5] !== variant || $[6] !== volunteerCount) {
    t4 = <Suspense fallback={t3}><VolunteerFilter volunteerCount={volunteerCount} limit={limit} defaultLocation={resolved} onGeoChange={handleGeoChange} variant={variant} /></Suspense>;
    $[3] = limit;
    $[4] = resolved;
    $[5] = variant;
    $[6] = volunteerCount;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = isResolving ? undefined : geoCoords;
  let t6;
  if ($[8] !== isResolving || $[9] !== limit || $[10] !== q || $[11] !== seoLevel || $[12] !== slug || $[13] !== t5 || $[14] !== variant) {
    t6 = <VolunteerList seoLevel={seoLevel} q={q} limit={limit} variant={variant} slug={slug} onVolunteerLoad={onVolunteerLoad} isDynamic={true} geoCoords={t5} isLocationResolving={isResolving} />;
    $[8] = isResolving;
    $[9] = limit;
    $[10] = q;
    $[11] = seoLevel;
    $[12] = slug;
    $[13] = t5;
    $[14] = variant;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t4 || $[17] !== t6) {
    t7 = <div className="grid gap-comfy-xl md:gap-roomy-xs">{t4}{t6}</div>;
    $[16] = t4;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
};